import { companyCenterApi } from 'app/services/api';

import { getDefaultErrorMessage } from 'utils/axios';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const COMPANY_CENTER_ACTION_TYPE = createNamedActions('companyCenter', {
  LOAD_SUMMARY_REQUEST: 'LOAD_SUMMARY_REQUEST',
  LOAD_SUMMARY_SUCCESS: 'LOAD_SUMMARY_SUCCESS',
  LOAD_SUMMARY_FAILURE: 'LOAD_SUMMARY_FAILURE',

  RESET_STATE: 'RESET_STATE',
});

// The summary owns its {loading, error, data} branch, so the thunk resolves its
// own request lifecycle and captures the error locally (the cards render a retry)
// instead of routing through the global error toast.
export const loadCompanyCenterSummaryAction =
  ({ subCompanyId }) =>
  async dispatch => {
    dispatch({ type: COMPANY_CENTER_ACTION_TYPE.LOAD_SUMMARY_REQUEST });

    try {
      const { data } = await companyCenterApi.getCompanyCenterSummary({ subCompanyId });

      return dispatch({
        type: COMPANY_CENTER_ACTION_TYPE.LOAD_SUMMARY_SUCCESS,
        payload: data ?? null,
      });
    } catch (error) {
      return dispatch({
        type: COMPANY_CENTER_ACTION_TYPE.LOAD_SUMMARY_FAILURE,
        payload: getDefaultErrorMessage(error),
      });
    }
  };

export const resetCompanyCenterAction = () => ({
  type: COMPANY_CENTER_ACTION_TYPE.RESET_STATE,
});
